import styled from "@emotion/styled";
import { Typography } from "@kaltura/ds-react-components";
import { systemWidth } from "@kaltura/mediaspace-shared-styled";

export const StyledChannels = styled("div")(({ theme }) => ({
    "&": systemWidth({ theme }),
    marginBottom: theme.spacing(7.5),
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
    marginTop: theme.spacing(4),
    marginBottom: 0,
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
        marginTop: theme.spacing(3),
    },
}));

export const StyledDescription = styled(Typography)(({ theme }) => ({
    marginTop: theme.spacing(3),
    marginBottom: 0,
    maxWidth: "57%",
    [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
        maxWidth: "83%",
    },
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
        marginTop: theme.spacing(2.5),
        maxWidth: "100%",
    },
}));

export const StyledContentContainer = styled("div")(({ theme }) => ({
    marginTop: theme.spacing(4),
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
        marginTop: theme.spacing(3),
    },
}));
